export const processList = ['选择用户类型', '签订用户服务协议', '填写注册信息', '注册成功'];
